var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRepository(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.5005V15.5005",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15.5005H13",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.5C0.611929 15.5 0.5 15.3881 0.5 15.25C0.5 15.1119 0.611929 15 0.75 15",
    stroke: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.75 15.5C0.888073 15.5 1 15.3881 1 15.25C1 15.1119 0.888073 15 0.75 15",
    stroke: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 15.5C15.1119 15.5 15 15.3881 15 15.25C15 15.1119 15.1119 15 15.25 15",
    stroke: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 15.5C15.3881 15.5 15.5 15.3881 15.5 15.25C15.5 15.1119 15.3881 15 15.25 15",
    stroke: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.50049C10.4853 4.50049 12.5 3.60506 12.5 2.50049C12.5 1.39592 10.4853 0.500488 8 0.500488C5.51472 0.500488 3.5 1.39592 3.5 2.50049C3.5 3.60506 5.51472 4.50049 8 4.50049Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.50049V5.50049C3.5 6.60516 5.51467 7.5005 8 7.5005C10.4853 7.5005 12.5 6.60516 12.5 5.50049V2.50049",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 5.50049V8.5005C3.5 9.60517 5.51467 10.5005 8 10.5005C10.4853 10.5005 12.5 9.60517 12.5 8.5005V5.50049",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepository);
export default __webpack_public_path__ + "static/media/repository.988ed0f7.svg";
export { ForwardRef as ReactComponent };